export const validFileTypes = {
    JPEG: 'image/jpeg',
    JPG: 'image/jpg',
    PNG: 'image/png',
    PDF: 'application/pdf',
    GIF: 'image/gif'
};